import { Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';

const footerLinks = {
  plataforma: [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Características', href: '#caracteristicas' },
    { label: 'Beneficios', href: '#beneficios' },
    { label: 'Blog', href: '#blog' }
  ],
  empresa: [
    { label: 'Sobre nosotros', href: '#nosotros' },
    { label: 'Contacto', href: '#contacto' },
    { label: 'Prensa', href: '#' },
    { label: 'Empleo', href: '#' }
  ],
  legal: [
    { label: 'Aviso legal', href: '#' },
    { label: 'Política de privacidad', href: '#' },
    { label: 'Política de cookies', href: '#' },
    { label: 'Términos y condiciones', href: '#' }
  ]
};

const socialLinks = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Youtube, href: '#', label: 'YouTube' }
];

export const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-[#051914] text-[#FBF5EA] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href="#inicio" className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_prestagro-agro/artifacts/nb3u8jqh_logo-prestagro.png" 
                alt="Prestagro Logo" 
                className="h-10 w-auto"
              />
            </a>
            <p className="text-[#FBF5EA]/60 mb-6 max-w-sm">
              La plataforma que conecta productores y prestadores rurales en Argentina 
              con tecnología, seguridad y confianza.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-[#FBF5EA]/10 rounded-full flex items-center justify-center hover:bg-[#A9CB68] hover:text-[#051914] transition-colors"
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Plataforma */}
          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-[#A9CB68]">
              Plataforma
            </h4>
            <ul className="space-y-3">
              {footerLinks.plataforma.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#FBF5EA]/60 hover:text-[#FBF5EA] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-[#A9CB68]">
              Empresa
            </h4>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#FBF5EA]/60 hover:text-[#FBF5EA] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-[#A9CB68]">
              Legal
            </h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-[#FBF5EA]/60 hover:text-[#FBF5EA] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#FBF5EA]/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#FBF5EA]/40 text-sm">
              © {new Date().getFullYear()} Prestagro S.A. Todos los derechos reservados.
            </p>
            <p className="text-[#FBF5EA]/40 text-sm">
              CUIT: 30-12345678-9 | Buenos Aires, Argentina
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
